import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function CreditScore({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M12.6667 7.02793C14.4469 7.1779 16.0661 7.92301 17.3275 9.0702L16.2121 9.86689C15.0589 8.906 13.5888 8.33329 12.0001 8.33329C8.35451 8.33329 5.33341 11.3488 5.33341 15.1505C5.33341 16.2306 5.57748 17.245 6.00898 18.1453L1.80071 20.1623C1.60911 19.7625 1.43979 19.35 1.2943 18.9264C0.887256 17.7414 0.666748 16.47 0.666748 15.1505C0.666748 12.9862 1.26022 10.9547 2.29433 9.21987L2.27927 9.20911L2.42952 8.99876C4.43409 5.80141 7.95781 3.66663 12.0001 3.66663C15.1768 3.66663 18.0332 4.98503 20.0837 7.10145L18.9849 7.88635C17.3328 6.24863 15.1231 5.18596 12.6667 5.02212V7.02793ZM11.3334 7.02793C9.08565 7.21731 7.0944 8.35559 5.75618 10.0541L4.12768 8.89087C5.82799 6.68978 8.40555 5.21742 11.3334 5.02212V7.02793ZM5.0189 11.166C4.37048 12.3424 4.00008 13.7007 4.00008 15.1505C4.00008 15.9581 4.1151 16.737 4.329 17.4719L2.50589 18.3457C2.17755 17.3401 2.00008 16.2655 2.00008 15.1505C2.00008 13.2717 2.50394 11.5094 3.38311 9.99757L5.0189 11.166Z"
        fill={iconColor}
      />
      <Path
        d="M19.5365 12.4079L18.3972 13.2218C18.5725 13.8319 18.6667 14.4789 18.6667 15.1505C18.6667 16.2306 18.4227 17.245 17.9912 18.1453L22.1995 20.1623C22.3911 19.7625 22.5604 19.35 22.7059 18.9264C23.1129 17.7414 23.3334 16.47 23.3334 15.1505C23.3334 13.4657 22.9738 11.8615 22.3267 10.415L21.2171 11.2075C21.7215 12.4207 22.0001 13.7533 22.0001 15.1505C22.0001 16.2655 21.8226 17.3401 21.4943 18.3457L19.6712 17.4719C19.8851 16.737 20.0001 15.9581 20.0001 15.1505C20.0001 14.1871 19.8365 13.264 19.5365 12.4079Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        d="M14.3987 16.5C14.5704 16.1476 14.6667 15.7517 14.6667 15.3333C14.6667 14.9954 14.6039 14.6721 14.4892 14.3746L21.7209 9.20911L20.9459 8.12414L13.7137 13.29C13.2503 12.9009 12.6525 12.6666 12.0001 12.6666C10.5273 12.6666 9.33341 13.8605 9.33341 15.3333C9.33341 15.7517 9.42977 16.1476 9.60149 16.5C10.0343 17.388 10.9457 18 12.0001 18C13.0545 18 13.9659 17.388 14.3987 16.5ZM12.0001 14C11.2637 14 10.6667 14.5969 10.6667 15.3333C10.6667 15.5449 10.7151 15.7414 10.8001 15.9159C11.018 16.3631 11.4749 16.6666 12.0001 16.6666C12.5253 16.6666 12.9821 16.3631 13.2001 15.9159C13.2851 15.7414 13.3334 15.5449 13.3334 15.3333C13.3334 14.5969 12.7365 14 12.0001 14Z"
        fill={iconColor}
      />
    </Svg>
  );
}
